import script from "./ArticlesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesPage.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlesPage.vue?vue&type=style&index=0&id=40aec32c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40aec32c"]])

export default __exports__